const globals = {
  states: [
    "AL",
    "AK",
    "AS",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FM",
    "FL",
    "GA",
    "GU",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MH",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "MP",
    "OH",
    "OK",
    "OR",
    "PW",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VI",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ],
  countries: ["United States"],
  devices: ["Dexcom CGM"],
  genders: ["Male", "Female", "Unknown"],
  individual_action_menu_options: [
    ["Complete this action", "complete"],
    ["Mark this action incomplete", "incomplete"],
    ["Unassign this action from provider", "unassign"],
    ["Assign this action to a provider", "assign"],
    ["Dismiss this action", "dismiss"],
    ["Defer this action", "defer"],
  ],
  complete_action_menu_options: ["Mark this action incomplete"],
  group_action_menu_options: [
    "Complete All Actions",
    "Unassign Actions From Provider",
  ],
  complete_group_action_menu_options: ["Mark All Actions Incomplete"],
  assignment_type_list_options: [
    "My Actions",
    "Assigned Actions",
    "Unassigned Actions",
    "All Actions",
  ],
};

export const raceOptions = ["Hispanic or Latino", "Not Hispanic or Latino"];
export const ethnicityOptions = [
  "White",
  "Black or African American",
  "American Indian or Alaskan Native",
  "Asian",
  "Native Hawaiian or Other Pacific Islander",
];

export const MONTHS = [
  { name: "January", number: 1 },
  { name: "February", number: 2 },
  { name: "March", number: 3 },
  { name: "April", number: 4 },
  { name: "May", number: 5 },
  { name: "June", number: 6 },
  { name: "July", number: 7 },
  { name: "August", number: 8 },
  { name: "September", number: 9 },
  { name: "October", number: 10 },
  { name: "November", number: 11 },
  { name: "December", number: 12 },
];

export const DRUG_THERAPY_PROBLEMS = [
  "Unnecessary Drug Therapy - No medical indication",
  "Unnecessary Drug Therapy - Duplicate therapy",
  "Unnecessary Drug Therapy - Non-drug therapy indicated",
  "Unnecessary Drug Therapy - Treating avoidable ADR",
  "Unnecessary Drug Therapy - Addictive/recreational",
  "Unnecessary Drug Therapy - Potentially Inappropriate Medication",
  "Needs Different Drug Product - More effective drug available",
  "Needs Different Drug Product - Condition refractory to drug",
  "Needs Different Drug Product - Dosage form inappropriate",
  "Needs Different Drug Product - Not effective for condition",
  "Adverse Drug Reaction - Undesirable effect",
  "Adverse Drug Reaction - Unsafe drug for patient",
  "Adverse Drug Reaction - Drug interaction",
  "Adverse Drug Reaction - Dosage administered or changed too rapidly",
  "Adverse Drug Reaction - Allergic reaction",
  "Adverse Drug Reaction - Contraindications present",
  "Noncompliance - Directions not understood",
  "Noncompliance - Patient prefers not to take",
  "Noncompliance - Patient forgets to take",
  "Noncompliance - Patient cannot afford",
  "Noncompliance - Cannot swallow/administer",
  "Noncompliance - Drug product not available",
  "Needs Additional Drug Therapy - Untreated condition",
  "Needs Additional Drug Therapy - Preventive/prophylactic",
  "Needs Additional Drug Therapy - Synergistic/potentiating",
  "Dosage Too Low - Wrong dose",
  "Dosage Too Low - Frequency inappropriate",
  "Dosage Too Low - Drug interaction",
  "Dosage Too Low - Duration inappropriate",
  "Dosage Too High- Wrong dose",
  "Dosage Too High - Frequency inappropriate",
  "Dosage Too High - Drug interaction",
  "Dosage Too High - Duration inappropriate",
  "Dosage Too High - Incorrect administration",
  "Other - Other",
];

export const DRUG_PROBLEM_RESOLUTIONS = [
  "Continue Current Treatment",
  "Change Dose - Increase",
  "Change Dose - Decrease",
  "Discontinue Medication",
  "Therapeutic Interchange",
  "Generic Substitution",
  "Start Different Medication",
  "Start Additional Medication",
  "Remove Patient Barrier",
  "Provide Additional Patient Education",
  "Vaccination Received",
  "Adherence Monitoring",
];

export const CONTACT_METHODS = {
  mobile_phone: [
    { value: "call", label: "Call" },
    { value: "text", label: "Text" },
  ],
  home_phone: [{ value: "call", label: "Call" }],
  email: [{ value: "email", label: "Email" }],
};

export const LANGUAGE_OPTIONS = [
  "English", "Spanish", "Arabic", "Mandarin Chinese", "Cantonese", "Vietnamese", "Tagalog",
  "Russian", "French", "German", "Hindi", "Korean", "Japanese", "Portuguese", "Italian",
  "Polish", "Farsi (Persian)", "Urdu", "Bengali", "Somali", "Hmong", "Greek", "Thai",
  "Armenian", "Burmese", "Swahili", "Punjabi", "Hebrew", "Lao", "Khmer", "Nepali", "Romanian",
  "Turkish", "Haitian Creole", "Serbian", "Croatian", "Bosnian", "Amharic", "Gujarati", "Tamil",
  "Telugu", "Malay", "Indonesian", "Czech", "Dutch", "Icelandic", "Finnish", "Norwegian",
  "Swedish", "Danish"
];

export const careers = [
  { value: "pharmacist", label: "Pharmacist" },
  { value: "health_coach", label: "Health Coach" },
  { value: "physician", label: "Physician" },
  { value: "student", label: "Student" },
  { value: "pharmacy_technician", label: "Pharmacy Technician" },
  { value: "community_health_worker", label: "Community Health Worker" },
  { value: "case_worker", label: "Case Worker" },
  { value: "social_worker", label: "Social Worker" },
  { value: "others", label: "Other" },
];

export default globals;
